import {forwardRef, InputHTMLAttributes, ReactElement} from "react";
import styled from "styled-components";

import {quicksandRegular, quicksandSemiBold} from "@/GlobalStyle";

const SearchInput = styled.input`
  width: -webkit-fill-available;
  padding: 0 10px;
  background-color: ${({theme}) => theme.colors.mediumSecondary};

  height: 40px;
  border-color: transparent;
  border-radius: 5px 5px 0 0;
  ${quicksandSemiBold}
  color:white;
  &::placeholder {
    color: white;
    ${quicksandRegular}
  }
  &:focus {
    border: 2px solid white;
    outline: 2px solid ${({theme}) => theme.colors.mediumSecondary};
  }
`;

export const SearchInputSelectCustom = forwardRef<
  HTMLInputElement,
  InputHTMLAttributes<HTMLInputElement> & {testId?: string}
>(({...props}, ref): ReactElement => {
  return <SearchInput {...props} ref={ref} data-testid={props.testId} />;
});
